import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["slide", "container", "prevButton", "nextButton"]

  connect() {
    this.updateButtons()

    this.containerTarget.addEventListener('scroll', this.updateButtons.bind(this))
  }

  move(event) {
    const vector = parseInt(event.params.vector)
    const slideWidth = this.slideTargets[0].offsetWidth
    const currentScroll = this.containerTarget.scrollLeft

    this.containerTarget.scrollTo({
      left: currentScroll + (vector * slideWidth),
      behavior: 'smooth'
    })
  }

  updateButtons() {
    const container = this.containerTarget
    this.prevButtonTarget.disabled = container.scrollLeft <= 10
    this.nextButtonTarget.disabled =
      container.scrollLeft + container.offsetWidth >= container.scrollWidth - 10
  }
}
